<template>
  <div class="page page-full">
    <div class="page-header with-actions">
      <h1>Client Features</h1>
      <div class="actions">
        <b-btn @click="createClientFeature" variant="success">Add Client Feature</b-btn>
      </div>
    </div>
    <dt-datatable ref="clientFeatureList"
                  :id="tableId"
                  url="/feature/client-feature-list"
                  :columns="columns"
                  :dt-options="dtOptions">

      <template #actions="{ data }">
        <div class="td-links-wrap">
          <a class="btn btn-link pl-0 text-success" @click="deleteClientFeature(data.id)">Delete</a>
        </div>
      </template>
    </dt-datatable>

    <client-feature-create-modal ref="clientFeatureCreateModal" @success="clientFeatureCreated"></client-feature-create-modal>
  </div>
</template>

<script>
  import { defaults } from "vue-datatables.net";

  import featureService from 'services/feature-service';

  import clientFeatureCreateModal from './client-feature-create-modal';

  export default {
    components: {
      clientFeatureCreateModal
    },

    data() {
      return {
        tableId: `client-feature-list-id${this.$auth.id}`,
        dtOptions: {
          language: {
            ...defaults.language,
            emptyTable: "You have no client features to manage."
          }
        },
      }
    },

    computed: {
      columns() {
        let columns = [
          { name: "ClientId" },
          { name: "Description" },
          { name: "Actions", data: false }
        ];

        return columns;
      }
    },

    methods: {
      async deleteClientFeature(id) {
        await featureService.deleteClientFeature(id);

        this.$root.successToast('Client feature deleted!')
        this.redrawTable();
      },

      createClientFeature() {
        this.$refs.clientFeatureCreateModal.show();
      },

      clientFeatureCreated() {
        this.redrawTable();
        this.$root.successToast('Client feature created!');
      },

      redrawTable() {
        this.$refs.clientFeatureList.draw();
      }
    }
  }
</script>